import { GameError } from '@/models/games/enums/GameError';
import { POPUP_TYPE } from '@/models/Popup';
import {
    giftRecordErrorThunk,
    giftRecordSuccessThunk,
} from '@/modules/analytic/thunk';
import { giftSliceActions } from '@/modules/main/slice/gift';
import { popupSliceActions } from '@/modules/popup/slice';
import { Dispatch } from '@reduxjs/toolkit';
import { CMDSpNbsGiftResponse, ICommand } from '../../live';
import { AbstractHandler } from '../AbstractHandler';

export class CMDSpNbsGiftHandler extends AbstractHandler {
    _command: CMDSpNbsGiftResponse;
    constructor(command: ICommand) {
        super();
        this._command = command as CMDSpNbsGiftResponse;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handle(dispatch: Dispatch<any>): void {
        const cmd = this._command;
        if (cmd.ReturnCode === this.SUCCESS_CODE) {
            dispatch(
                popupSliceActions.open(
                    'send_gift_confirm',
                    POPUP_TYPE.POPUP,
                    undefined,
                    2000
                )
            );
            dispatch(
                giftSliceActions.updateConfirmedGift({
                    UUID: cmd.UUID,
                    HostID: cmd.HostID,
                    GiftID: cmd.GiftID,
                })
            );
            dispatch(giftRecordSuccessThunk({ uuid: cmd.UUID }));
        } else if (cmd.ReturnCode === GameError.NotEnoughMoney) {
            dispatch(popupSliceActions.open('Insufficient_balance'));
            dispatch(giftRecordErrorThunk({ uuid: cmd.UUID }));
        } else {
            dispatch(popupSliceActions.open('send_gift_error'));
            dispatch(giftRecordErrorThunk({ uuid: cmd.UUID }));
        }
    }
}
